import { tns } from 'tiny-slider/src/tiny-slider.module';

app.product = () => {
  function init() {
    logoSlider();
  }

  let logoSlider = () => {
    const logOpts = {
      container: '.logo-client',
      items: 9,
      slideBy: 1,
      speed: 1000,
      autoplay: true,
      controls: false,
      responsive: {
        400: {
          items: 4
        },
        992: {
          items: 9
        }
      },
      nav: false,
      autoplayButtonOutput: false
    };
    const slider = tns(logOpts);
  };


  return init();
};
